import { useRef } from "react";
import VoiceService from "../services/voiceService";

export default function useMicrophone() {

    const audioContext = useRef<AudioContext | null>(null);
    const workletNode = useRef<AudioWorkletNode | null>(null);
    const streamRef = useRef<MediaStream | null>(null);

    const start = async () => {

        streamRef.current = await navigator.mediaDevices.getUserMedia({
            audio: {
                channelCount: 1,
                echoCancellation: true,
                noiseSuppression: true,
                autoGainControl: true
            }
        });

        // Must match the backend's expected sample rate (services/audio.py SAMPLE_RATE).
        audioContext.current = new AudioContext({ sampleRate: 16000 });

        await audioContext.current.audioWorklet.addModule(
            "/audio/pcm-processor.js"
        );

        const source =
            audioContext.current.createMediaStreamSource(
                streamRef.current
            );

        workletNode.current = new AudioWorkletNode(
            audioContext.current,
            "pcm-processor"
        );

        workletNode.current.port.onmessage = (event) => {

            VoiceService.sendAudio(event.data);

        };

        source.connect(workletNode.current);

        // Required to keep the worklet processing
        workletNode.current.connect(audioContext.current.destination);
    };

    const stop = async () => {

        workletNode.current?.disconnect();

        streamRef.current?.getTracks().forEach(track => track.stop());

        await audioContext.current?.close();
    };

    return {
        start,
        stop
    };
}